export default "__VITE_ASSET__DLaum8GT__"